class FAQ {
    private items: NodeListOf<HTMLElement>;

    constructor(private element: HTMLElement) {
        this.items = this.element.querySelectorAll<HTMLElement>('.faq-item');
        this.init();
    }

    private init() {
        this.items.forEach((item) => {
            item?.addEventListener('click', () => this.toggle(item));
        });
    }

    private toggle(item: HTMLElement) {
        if (item.classList.contains('active')) {
            this.hide(item);
        } else {
            this.items.forEach((item) => {
                this.hide(item);
            });

            this.show(item);
        }
    }

    private hide(item: HTMLElement) {
        item.classList.remove('active');
    }

    private show(item: HTMLElement) {
        item.classList.add('active');
    }
}

window.addEventListener('load', () => {
    const faqs = document.querySelectorAll<HTMLElement>('.faq-component');
    faqs?.forEach(faq => new FAQ(faq));
});